<template>
    <div class="question mb-4">
        <div class="mb-3">
            <div class="question__title">Пожалуйста, оцените по степени важности следующие способы, с помощью которых предприятие преодолевало нехватку навыков различных категорий сотрудников за последние 12 месяцев.
            </div>
            <div class="question__desc caption">Поставьте соответствующую цифру от 1 до 5-ти в правой колонке, где 1-не важно, 5-наиболее важно.</div>
        </div>

        <table class="table-skills">
            <thead class="table-skills__header">
                <tr>
                    <td rowspan="2">Управленческие инструменты развития навыков</td>
                    <td colspan="3">Оценка важности</td>
                </tr>
                <tr>
                    <td>Рабочий персонал</td>
                    <td>Специалисты и инженеры</td>
                    <td>Руководители</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(id, index) in fids" v-if="index%3 === 0" :key="id">
                    <td v-if="list[id].text">{{ list[id].text }}</td>
                    <td>
                        <question-radio
                                has-index
                                :index-offset="0"
                                :isSingle="true"
                                v-if="list[fids[index]].type === 'radio' && list[fids[index]].answers.length"
                                :horizontal="!!list[fids[index]].is_horizontal"
                                :items="list[fids[index]].answers"
                                @input="$emit('sendAnswer', $event, fids[index])"
                        />
                    </td>
                    <td>
                        <question-radio
                                has-index
                                :index-offset="0"
                                :isSingle="true"
                                v-if="list[fids[index + 1]].type === 'radio' && list[fids[index + 1]].answers.length"
                                :horizontal="!!list[fids[index + 1]].is_horizontal"
                                :items="list[fids[index + 1]].answers"
                                @input="$emit('sendAnswer', $event, fids[index + 1])"
                        />
                    </td>
                    <td>
                        <question-radio
                                has-index
                                :index-offset="0"
                                :isSingle="true"
                                v-if="list[fids[index + 2]].type === 'radio' && list[fids[index + 2]].answers.length"
                                :horizontal="!!list[fids[index + 2]].is_horizontal"
                                :items="list[fids[index + 2]].answers"
                                @input="$emit('sendAnswer', $event, fids[index + 2])"
                        />
                    </td>
                </tr>
                <tr>
                    <td v-if="list[last[0]].text">{{ list[last[0]].text }}</td>
                    <td>
                        <question-input
                                v-if="list[last[0]].type === 'input'"
                                @input="$emit('sendAnswer', $event, last[0])"
                        />
                    </td>
                    <td>
                        <question-input
                                v-if="list[last[1]].type === 'input'"
                                @input="$emit('sendAnswer', $event, last[1])"
                        />
                    </td>
                    <td>
                        <question-input
                                v-if="list[last[2]].type === 'input'"
                                @input="$emit('sendAnswer', $event, last[2])"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import QuestionRadio from '@/components/question/radio'
    import QuestionInput from '@/components/question/input'

    export default {
        components: {
            QuestionInput,
            QuestionRadio
        },
        props: {
            ids: Array
        },
        data () {
            return {
                items: [],
                value: ''
            }
        },
        computed: {
            ...mapGetters('questions', ['questions']),
            fids () {
                return this.ids.slice(0, this.ids.length - 3)
            },
            last () {
                return this.ids.slice([this.ids.length - 3])
            },
            list () {
                let out = {}

                this.questions.forEach(item => {
                    out[item.id] = item
                })

                return out
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .question {
        &__title {}
        &__desc {
            color #777777
        }
    }

    .table-skills {
        width 100%
        border-collapse collapse

        &__header {
            text-align center
        }

        td {
            padding .5rem 1rem
            border 1px solid rgba(0,0,0,0.42)
        }
    }
</style>
